module.exports = __webpack_public_path__ + "img/logo.2067a41c.png";